import React from "react";

function TwitterIcon() {
  return (
    <svg
      width='34'
      height='28'
      viewBox='0 0 34 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M30.5069 6.97807C30.5294 7.28505 30.5294 7.59028 30.5294 7.8955C30.5294 17.2364 23.5173 28 10.7024 28C6.75432 28 3.08651 26.8405 0 24.8267C0.560554 24.8916 1.10035 24.9144 1.68339 24.9144C4.82006 24.9221 7.8679 23.8587 10.3356 21.8955C8.88135 21.8688 7.47158 21.3823 6.30318 20.504C5.13478 19.6256 4.26606 18.3993 3.81834 16.9961C4.24913 17.061 4.68166 17.1049 5.13495 17.1049C5.75952 17.1049 6.38754 17.0172 6.97059 16.8646C5.39232 16.5415 3.97314 15.6741 2.95436 14.4099C1.93558 13.1458 1.38009 11.5628 1.38235 9.93033V9.84263C2.31142 10.3671 3.38927 10.6951 4.53114 10.739C3.57455 10.0945 2.79017 9.21994 2.24799 8.19334C1.70581 7.16675 1.42269 6.02004 1.42388 4.85553C1.42388 3.54342 1.76817 2.34006 2.37197 1.29107C4.12308 3.47504 6.3071 5.26173 8.78259 6.53542C11.2581 7.80912 13.9698 8.54141 16.7422 8.68488C16.6349 8.15863 16.5692 7.61308 16.5692 7.06578C16.5687 6.13776 16.7487 5.21875 17.0987 4.36128C17.4488 3.50381 17.9621 2.7247 18.6093 2.06849C19.2565 1.41228 20.025 0.891838 20.8707 0.536912C21.7164 0.181987 22.6228 -0.000460257 23.5381 8.71931e-07C25.545 8.71931e-07 27.3564 0.852525 28.6298 2.2313C30.1899 1.9254 31.6861 1.34794 33.0519 0.524496C32.5319 2.1573 31.4425 3.54184 29.9879 4.41874C31.3716 4.25873 32.7239 3.88978 34 3.32415C33.0469 4.73291 31.866 5.96828 30.5069 6.97807Z'
        fill='#FAF9FC'
      />
    </svg>
  );
}

export default TwitterIcon;
